import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdTrash: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 13 15" fill="none" {...props}>
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        d="M12.6186 2.1477H9.23297V1.58663C9.23232 1.22422 9.08874 0.876678 8.83342 0.619539C8.57799 0.362272 8.23144 0.216197 7.86901 0.213074H5.12189C4.75774 0.213721 4.40871 0.358602 4.15135 0.616084C3.89387 0.873566 3.74897 1.22259 3.74834 1.58663V2.1477H0.362742C0.16237 2.1477 0 2.31007 0 2.51044C0 2.71081 0.16237 2.87318 0.362742 2.87318H1.29614V12.805C1.29679 13.2492 1.47352 13.6751 1.78768 13.9893C2.10183 14.3035 2.52773 14.4802 2.972 14.4809H10.019C10.4633 14.4802 10.8891 14.3035 11.2033 13.9893C11.5175 13.6752 11.6942 13.2493 11.6949 12.805V2.87318H12.6187C12.8189 2.87318 12.9814 2.71081 12.9814 2.51044C12.9814 2.31007 12.8189 2.1477 12.6187 2.1477H12.6186ZM4.47379 1.58663C4.47379 1.41476 4.54203 1.24989 4.66359 1.12835C4.78515 1.00678 4.94999 0.938553 5.12187 0.938553H7.86898C8.04086 0.938553 8.20572 1.00678 8.32727 1.12835C8.44883 1.24991 8.51706 1.41475 8.51706 1.58663V2.1477H4.47369L4.47379 1.58663ZM10.9692 12.805C10.9692 13.0571 10.8691 13.2988 10.6909 13.477C10.5126 13.6552 10.2709 13.7553 10.0188 13.7553H2.97181C2.71972 13.7553 2.47801 13.6552 2.29977 13.477C2.12153 13.2988 2.02146 13.0571 2.02146 12.805V2.87316H10.9691L10.9692 12.805Z"
        fill="currentColor"
      />
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        d="M4.11119 5.0835C3.91081 5.0835 3.74844 5.24587 3.74844 5.44624V10.6987C3.74844 10.8991 3.91081 11.0615 4.11119 11.0615C4.31145 11.0615 4.47393 10.8991 4.47393 10.6987V5.44624C4.47393 5.24587 4.31145 5.0835 4.11119 5.0835Z"
        fill="currentColor"
      />
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        d="M6.49549 5.0835C6.29512 5.0835 6.13275 5.24587 6.13275 5.44624V10.6987C6.13275 10.8991 6.29512 11.0615 6.49549 11.0615C6.69587 11.0615 6.85824 10.8991 6.85824 10.6987V5.44624C6.85824 5.24587 6.69587 5.0835 6.49549 5.0835Z"
        fill="currentColor"
      />
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        d="M8.51715 5.44636V10.6989C8.51715 10.8992 8.67963 11.0616 8.87989 11.0616C9.08027 11.0616 9.24264 10.8992 9.24264 10.6989V5.44636C9.24264 5.24599 9.08027 5.08362 8.87989 5.08362C8.67963 5.08362 8.51715 5.24599 8.51715 5.44636Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdTrash;
